
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donde-estamos/[slug]",
      function () {
        return require("private-next-pages/donde-estamos/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donde-estamos/[slug]"])
      });
    }
  